<template>
  <div class="app-payment-card">
    <div class="app-payment-card__container">
      <vs-row style="row-gap:.5rem">
        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" style="position: relative">
          <vs-input label="Nome do Titular do Cartão" v-model="form.name"
            class="app-payment-card__container-name required-field" :danger="invalidField.name"
            :danger-text="alertMessage.name" @blur="checkPaymentName"
            @keyup="form.name = onlyFirstLetterCapitalized($event.target.value)" @input="handleChange('name')" />
        </vs-col>

        <vs-col vs-xs="12" vs-sm="6" vs-lg="6" style="position: relative">
          <vs-input label="Número do cartão" v-model="form.card" class="app-payment-card__container-card required-field"
            v-mask="['#### #### #### ####']" :danger="invalidField.card" :danger-text="alertMessage.card"
            @blur="checkPaymentCard" @input="handleChange('card')" />

          <img v-if="flag" class="app-payment-card__container-flag"
            :src="require(`@/assets/svgs/components/credit-card/${flag}.svg`)" />
        </vs-col>

        <vs-col vs-xs="8" vs-sm="4" vs-lg="4">
          <vs-input label="Data de vencimento" v-model="form.expiration"
            class="app-payment-card__container-expiration required-field" v-mask="['##/##']"
            :danger="invalidField.expiration" :danger-text="alertMessage.expiration" @blur="checkPaymentExpiration"
            @input="handleChange('expiration')" />
        </vs-col>

        <vs-col vs-xs="4" vs-sm="2" vs-lg="2">
          <vs-input label="CVV" v-model="form.cvv" class="app-payment-card__container-cvv required-field"
            v-mask="['####']" :danger="invalidField.cvv" :danger-text="alertMessage.cvv" @blur="checkPaymentCvc"
            @input="handleChange('cvv')" />
        </vs-col>

        <vs-col vs-xs="12" :vs-sm="installments > 1 ? 6 : 12" :vs-lg="installments > 1 ? 6 : 12">
          <vs-input label="CPF do titular do cartão" v-model="form.cpf"
            class="app-payment-card__container-cpf required-field" v-mask="['###.###.###-##']"
            :danger="invalidField.cpf" :danger-text="alertMessage.cpf" @blur="checkPaymentCpf"
            @input="handleChange('cpf')" />
        </vs-col>

        <vs-col v-if="installments > 1" vs-xs="12" vs-sm="6" vs-lg="6">
          <vs-select v-model="form.installment" label="Parcelamento"
            class="app-payment-card__container-select required-field" @input="handleChange('installments')">
            <vs-select-item v-for="option in computedInstallments" :key="option.id" :value="option.value"
              :text="option.text" />
          </vs-select>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import mixins from "@/mixins/mixins.js"
import cardList from '@/constants/cards'

export default {
  name: 'AppPaymentCard',

  mixins: [mixins],

  props: {
    value: {
      type: Number,
      required: true
    },
    installments: {
      type: Number,
      default: 1
    }
  },

  data () {
    return {
      alertMessage: {
        name: '',
        card: '',
        expiration: '',
        cvv: '',
        cpf: ''
      },
      form: {
        name: '',
        card: '',
        expiration: '',
        installment: 1,
        cvv: '',
        cpf: ''
      },
      invalidField: {
        name: false,
        card: false,
        expiration: false,
        cvv: false,
        cpf: false
      },
      flag: ''
    }
  },

  computed: {
    computedInstallments () {
      const intCls = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

      return Array(12)
        .fill()
        .map((_, idx) => {
          const value = idx + 1

          return { value, text: `${value} de ${intCls.format(this.value / value)}` }
        })
    },
    isAllChecked () {
      Object.keys(this.alertMessage).forEach((field) => {
        this.invalidField[field] = !!this.alertMessage[field]
      })

      const formCount = Object.values(this.form).filter(val => val).length
      const invalidCount = Object.values(this.invalidField).filter(val => val).length

      return formCount === Object.keys(this.form).length && invalidCount === 0
    }
  },

  methods: {
    clearErrors (field) {
      this.invalidField[field] = false
      this.alertMessage[field] = null
    },

    handleChange (field) {
      this.clearErrors(field)
      this.$emit('setPayment', this.form)
    },

    checkPaymentName () {
      this.clearErrors('name')

      if (!this.form.name) {
        this.alertMessage.name = "Campo obrigatório"
      } else if (!this.testFullName(this.form.name)) {
        this.alertMessage.name = "Insira o nome completo"
      }

      this.invalidField.name = !!this.alertMessage.name
      this.$emit('set:card', this.form)
    },
    checkPaymentCard () {
      this.clearErrors('card')

      if (!this.form.card) {
        this.alertMessage.card = "Campo obrigatório"
      }

      this.invalidField.card = !!this.alertMessage.card
      this.$emit('set:card', this.form)
    },
    checkPaymentExpiration () {
      this.clearErrors('expiration')

      const [month, year] = this.form.expiration.split('/').map(dt => parseInt(dt, 10))

      if (this.form.expiration.split('/').filter(val => val).length < 2) {
        this.alertMessage.expiration = "Campo obrigatório"
      } else {
        const today = new Date()
        const currYear = today.getFullYear() - 2000
        const currMonth = today.getMonth() + 1

        if (year < currYear || month > 12 || year - currYear > 10 || year === currYear && month < currMonth) {
          this.alertMessage.expiration = "Expiração inválido"
        }
      }

      this.invalidField.expiration = !!this.alertMessage.expiration
      this.$emit('set:card', this.form)
    },

    checkPaymentCvc () {
      this.clearErrors('cvv')

      if (!this.form.cvv) {
        this.alertMessage.cvv = "Campo obrigatório"
      } else if (this.form.cvv.replace(/[^\d]+/g, "").length < 3) {
        this.alertMessage.cvv = "Número inválido"
      }

      this.invalidField.cvv = !!this.alertMessage.cvv
      this.$emit('set:card', this.form)
    },

    checkPaymentCpf () {
      this.clearErrors('cpf')

      if (!this.form.cpf) {
        this.alertMessage.cpf = "Campo obrigatório"
      } else if (this.form.cpf.replace(/[^\d]+/g, "").length < 11) {
        this.alertMessage.cpf = "Número de cpf inválido"
      }

      this.invalidField.cpf = !!this.alertMessage.cpf
      this.$emit('set:card', this.form)
    },

    async emitData () {
      this.$emit('setPayment', { card: this.form, isValid: await this.isAllChecked })
    },

    async checkPaymentCardFields () {
      await this.checkPaymentName()
      await this.checkPaymentCard()
      await this.checkPaymentExpiration()
      await this.checkPaymentCvc()
      await this.checkPaymentCpf()

      return this.isAllChecked
    }
  },

  watch: {
    'form.card' (val) {
      if (val.length > 4) {
        const flags = cardList
          .map((card) => card.bin.test(val) ? card.flag : '')
          .filter((flag) => flag)

        if (flags.length) {
          this.flag = flags[0]
        }
      } else {
        this.flag = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-payment-card {
  &__container {
    &-card {
      flex-grow: 1;

      &::v-deep {
        .vs-input--input {
          padding-right: 3rem;
        }
      }
    }

    &-flag {
      height: 38px;
      position: absolute;
      right: 1rem;
      top: 1.8rem;
      width: 38px;
    }
  }

  &::v-deep {
    .vs-input {
      &--input {
        height: 3rem;
        padding: 0 .7rem;
      }

      &--label {
        font-weight: 500;
        margin-top: 0;
        text-transform: none;
      }
    }

    .con-select,
    .vs-con-input-label {
      width: 100%;

      .vs-select--input {
        height: 3rem;
        padding: 0 .75rem;
      }
    }
  }
}
</style>